import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsFilesAccountParser } from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount.parser"
import { IWarrantsFilesAccount } from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount.types"
import {
  Financials_Warrants_Files_Account_Bool_Exp,
  Financials_Warrants_Files_Account_Order_By,
  GetWarrantsFilesAccountsQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsFilesAccountListResult {
  files: IWarrantsFilesAccount[]
  totalCount: number
}

/** "All Filters" selections applied to the DCA Files accounts table. */
export interface WarrantsFilesAccountFilters {
  /** Filter to a single warrants_files_account_status, or null for any. */
  status: string | null
  /** Filter to a single warrants_files_type, or null for any. */
  fileType: string | null
}

class WarrantsFilesAccountServiceClass {
  getFiles(
    search: string,
    filters: WarrantsFilesAccountFilters,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Files_Account_Order_By,
  ): QueryResult<WarrantsFilesAccountListResult> {
    const where: Financials_Warrants_Files_Account_Bool_Exp = {
      account_number: { _ilike: `%${search}%` },
    }
    if (filters.status) {
      where.status = { _eq: filters.status }
    }
    if (filters.fileType) {
      where.file_type = { _eq: filters.fileType }
    }

    return useQuery({
      ...HasuraQueries.warrants.filesAccounts(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { files: [], totalCount: 0 },
      parserFn: (
        data: GetWarrantsFilesAccountsQuery,
      ): WarrantsFilesAccountListResult => ({
        files: data.financials_warrants_files_account.map(
          WarrantsFilesAccountParser.toDomain,
        ),
        totalCount:
          data.financials_warrants_files_account_aggregate.aggregate?.count ??
          0,
      }),
    })
  }
}

export const WarrantsFilesAccountService =
  new WarrantsFilesAccountServiceClass()
